import axios, { AxiosResponse } from 'axios';
import { RoomApiResponse, RoomTypeApiResponse } from '../types/api/roomApi';

const API_URL = process.env.REACT_APP_API_URL;

const customHeaders = {
    'Content-Type': 'application/json'
};

// Sign in function with typed parameters and response
export const getRoomTypeDataService = async (): Promise<AxiosResponse<RoomTypeApiResponse>> => {
    try {
        const response = await axios.get(API_URL + 'roomtype', { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};

export const getRoomDataService = async (id: string): Promise<AxiosResponse<RoomApiResponse>> => {
    try {
        const response = await axios.get(API_URL + 'roomtype/' + id, { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};

